export interface ArticleBlock {
  type: 'p' | 'h' | 'quote' | 'ul';
  text: string;
}

export interface Article {
  id: number;
  title: string;
  excerpt: string;
  channel: string;
  author: string;
  role: string;
  verified: 'verified' | 'pending' | 'update';
  cover: string;
  date: string;
  views: number;
  comments: number;
  heat: number;
  tags: string[];
  body: ArticleBlock[];
}

export interface Channel {
  key: string;
  name: string;
  desc: string;
}

export const channels: Channel[] = [
  { key: 'all', name: '全部', desc: '全站最新的一手爆料与职场动态' },
  { key: 'tech', name: '科技大厂', desc: '大厂组织变动、裁员补偿、年终奖、股权与内部流程' },
  { key: 'platform', name: '互联网与平台', desc: '平台规则、生态商家、一线运营与增长内幕' },
  { key: 'finance', name: '金融与投行', desc: '年终奖、晋升、狼性文化与项目内幕' },
  { key: 'consumer', name: '消费与零售', desc: '渠道、供应链、门店与品牌的一线观察' },
  { key: 'health', name: '医疗与大健康', desc: '医药企业合规、研发节奏与人才流动' },
  { key: 'career', name: '职场观察', desc: '加班文化、竞业、公积金、跳槽与职场成长' },
];

export const articles: Article[] = [
  {
    id: 1,
    title: '华南某智能硬件大厂启动新一期组织调整，内部流出的补偿口径与时间线',
    excerpt: '多位前员工向平台反馈，该厂产研与市场部门进入「资源重新分配」周期，补偿按 N+1 起步、具体因司龄浮动。这里整理了一手口径与时间线。',
    channel: 'tech',
    author: '离职三月的阿凯',
    role: '前产研员工',
    verified: 'verified',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20modern%20office%20buildings%20silhouette%20in%20warm%20evening%20ink%20tones%2C%20abstract%20flowchart%20and%20timeline%20lines%20overlay%2C%20retro%20newsprint%20texture%2C%20vermilion%20red%20and%20cream%20palette%2C%20no%20text&width=1200&height=760&seq=cover-tech-org&orientation=landscape',
    date: '09-04',
    views: 182300,
    comments: 406,
    heat: 96,
    tags: ['组织调整', 'N+1', '智能硬件'],
    body: [
      { type: 'p', text: '事情其实从上月底就开始传了。我离职前在华南那家做智能硬件的厂子里待了快三年，认识的老同事陆续发来消息，说产研和市场两个 BU 的预算被重新审计，Q3 还没结束就开始盘人头。' },
      { type: 'h', text: '补偿口径：不是一刀切' },
      { type: 'p', text: '多位已拿到方案的同事反馈，这次并不是网传的「全员 N+1」。实际是分档处理：司龄满三年的核心研发一般是 N+2，普通岗位多数为 N+1，试用期或入职不满一年的基本是协商补偿。关键是交金基数是否按过去 12 个月平均工资算，这点有人拿到了、有人没拿到，争议最大。' },
      { type: 'quote', text: 'HR 话术是「战略聚焦」，但我们私下都明白，就是现金流要紧着新芯片项目。拿到方案别急着签，先把年假、调休和未发的加班费一起谈进去。' },
      { type: 'h', text: '时间线梳理' },
      { type: 'ul', text: '8 月下旬：内部 OA 上线「组织优化申报」入口' },
      { type: 'ul', text: '9 月上旬：各 BU 名单逐步确定，先管理层、后员工' },
      { type: 'ul', text: '9 月中旬：第一批进入离职面谈，方案含 N 或 N+ 档位' },
      { type: 'p', text: '有 HR 背景的前同事提醒：面谈时全程录音不一定被允许，但务必留书面沟通记录。补偿金额、到账日期、社保衔接写到纸面上才算数。' },
      { type: 'p', text: '截至发稿，平台已收到 40+ 条同源投稿，我们标注为「已核实」，但具体数字以公司与个人劳动合同及书面通知为准，请勿据此直接对峙公司。后续有更新会持续补充。' },
    ],
  },
  {
    id: 2,
    title: '北京某内容平台被曝调整跟投机制，创作者分成出现「隐藏上限」',
    excerpt: '平台侧的知情人士投稿称，新版创作者成长体系中，流量分成在达到一定梯度后增速明显放缓，疑似存在未公开的上限。',
    channel: 'platform',
    author: 'ID是数字的运营',
    role: '前内容运营',
    verified: 'pending',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20collage%20of%20analytics%20charts%20and%20coins%20growing%20into%20a%20graph%2C%20warm%20cream%20paper%20background%20with%20retro%20newspaper%20grid%2C%20amber%20gold%20and%20vermilion%20red%20accents%2C%20abstract%2C%20no%20text&width=1200&height=760&seq=cover-platform-split&orientation=landscape',
    date: '09-03',
    views: 95600,
    comments: 212,
    heat: 84,
    tags: ['创作者', '分成', '平台规则'],
    body: [
      { type: 'p', text: '我做过两年多内容运营，见过不少创作者对平台的「成长体系」一头雾水。这轮新版规则上线后，几个头部号私下对过账，发现一个共同现象：单条爆款带来的收益，在数据翻倍后并没有等比例翻倍。' },
      { type: 'h', text: '「隐藏上限」是怎么被发现的' },
      { type: 'p', text: '一位做了三年知识区的创作者给我看过后台：同样是 100 万播放，9 月分的收益比 5 月少了约三成，而他的粉丝量、完播率都在涨。把历史数据拉成曲线后，收益在某个区间后明显走平，像被「压了头」。' },
      { type: 'quote', text: '平台口径是「收益波动受广告市场影响」，但多账号数据同时在同一梯度走平，很难用单纯的市场波动解释。' },
      { type: 'ul', text: '增长线：播放量 10 万以下，分成几乎线性' },
      { type: 'ul', text: '拐点区：单条过 50 万后，增速放缓约一档' },
      { type: 'ul', text: '顶部：大爆款收益有封顶迹象，需更多投稿佐证' },
      { type: 'p', text: '这份投稿目前我们标为「待核实」，因为它缺少可公开核对的合同条款截图。欢迎有新版创作者协议的当事人补充原文对照，我们会据此更新结论。' },
    ],
  },
  {
    id: 3,
    title: '沪上某券商投行部年终奖传闻再起，内部信把「级别」与「年份」绑定',
    excerpt: '知情人士称，年终奖发放改为更看重职级而非当年项目收益，基层分析师的到手落差最明显。多位员工表示正在观望是否跳槽。',
    channel: 'finance',
    author: '半夜改 PPT 的',
    role: '知情人士',
    verified: 'update',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20skyscraper%20and%20stock%20chart%20in%20warm%20ink%20silhouette%2C%20envelope%20and%20coins%20motif%2C%20cream%20paper%20with%20retro%20newspaper%20lines%2C%20deep%20amber%20and%20vermilion%20palette%2C%20no%20text&width=1200&height=760&seq=cover-finance-bonus&orientation=landscape',
    date: '09-02',
    views: 128400,
    comments: 318,
    heat: 91,
    tags: ['投行', '年终奖', '职级'],
    body: [
      { type: 'p', text: '这则传闻其实从每年这个时候都会出现，但今年的口径有点不一样。往年的潜规则是「项目收益好就多发」，今年流出的内部信把奖金权重更多押到了职级与司龄上。' },
      { type: 'h', text: '基层分析师落差最大' },
      { type: 'p', text: '据知情人士测算，同一年完成项目数量相近的情况下，资深 VP 与初级分析师的奖金倍数差距可能进一步拉大。初级岗位过去靠「多劳多得」补收入的期望，今年大概率要落空。' },
      { type: 'quote', text: '部门负责人会上说的是「让奖金回归岗位价值」，翻译过来就是：平台和层级比个人当年产出更值钱。' },
      { type: 'ul', text: '9 月初：内部邮件预告考核口径变化' },
      { type: 'ul', text: '预计 11 月底：完成年度评价并锁定奖金池' },
      { type: 'ul', text: '此前投稿补充：已有 2 位分析师确认年后看机会' },
      { type: 'p', text: '这条标注为「网友补充」：早前有用户称部分团队可能吃到「业务量缩减」的利空，与本次内部信相互印证，但缺少书面证据，暂不升级为已核实。' },
    ],
  },
  {
    id: 4,
    title: '某连锁咖啡品牌门店排班系统「被曝砍工时」，一线伙伴喊话管理层看数据',
    excerpt: '多名门店员工投稿称新排班算法上线后，周工时被卡得更紧，晚班津贴与新工时标准衔接出现争议。品牌方暂未公开回应。',
    channel: 'consumer',
    author: '打烊的店长助理',
    role: '前门店员工',
    verified: 'pending',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20coffee%20shop%20counter%20and%20barista%20in%20warm%20ink%20style%2C%20schedule%20calendar%20overlay%2C%20retro%20newsprint%20cream%20background%2C%20amber%20and%20vermilion%20accents%2C%20no%20text&width=1200&height=760&seq=cover-consumer-shift&orientation=landscape',
    date: '09-01',
    views: 74200,
    comments: 187,
    heat: 78,
    tags: ['连锁餐饮', '排班', '工时'],
    body: [
      { type: 'p', text: '我是这个品牌华东区的离职员工，走之前把新排班系统看得比较清楚。很多门店的周工时被算法压到排班线附近，晚班补贴的起算标准也换了算法。' },
      { type: 'h', text: '工时「被优化」的三处细节' },
      { type: 'ul', text: '周排班从「按客流」变成「按客流 × 固定系数」，淡季工时常被砍半' },
      { type: 'ul', text: '晚班津贴起算时间从 22 点改到 23 点，晚班人数多的门店受影响最大' },
      { type: 'ul', text: '换休申请需提前 7 天，临时请假基本只能调，难补班' },
      { type: 'quote', text: '不是反对智能排班，是希望管理层能看到我们实际站岗的小时数，而不是只看系统里的「合理排班」。' },
      { type: 'p', text: '我们收到同品牌 6 个城市的一线投稿，表述高度一致，但品牌官方口径未出，因此暂标「待核实」。若有在职伙伴补充考勤截图，可协助更新。' },
    ],
  },
  {
    id: 5,
    title: '某药企研发部门被曝「项目大挪移」，管线负责人离职后由谁接棒成谜',
    excerpt: '知情人士投稿称，某创新药企把两个早期项目整体划转，原负责研发的高管去向成谜，部门内人心浮动，招聘节奏明显放缓。',
    channel: 'health',
    author: '实验服还没洗',
    role: '前研发人员',
    verified: 'update',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20laboratory%20and%20molecule%20structure%20in%20warm%20ink%20tones%2C%20abstract%20organization%20chart%20overlay%2C%20cream%20paper%20with%20retro%20newspaper%20texture%2C%20vermilion%20and%20amber%20palette%2C%20no%20text&width=1200&height=760&seq=cover-health-pipeline&orientation=landscape',
    date: '08-31',
    views: 88100,
    comments: 149,
    heat: 81,
    tags: ['医药', '研发', '高管变动'],
    body: [
      { type: 'p', text: '坐标长三角某创新药企。内部 OA 这两天悄无声息地上线了两个「研发项目整体划转」的流程，涉及的两个早期管线原负责人属于同一高管条线，而这位高管的对外 title 已经悄悄撤下。' },
      { type: 'h', text: '部门里的三个信号' },
      { type: 'ul', text: '招聘：研发岗 JD 大批下架，近期只有替换性招聘' },
      { type: 'ul', text: '预算：中期课题经费申请口径收紧，审批层级增加' },
      { type: 'ul', text: '传言：内部流传「调整到位前不再批新 project」的说法' },
      { type: 'quote', text: '医药行业最怕的不是项目黄，而是项目黄了还说不清谁负责。希望公司尽早公示新的管线负责人。' },
      { type: 'p', text: '本条为「网友补充」：早前有同源投稿称该高管可能转向外部 BD，但无实据，故维持待补充状态，欢迎更新。' },
    ],
  },
  {
    id: 6,
    title: '「竞业限制」成为跳槽头号拦路虎，HR 亲述如何判断协议是否会被执行',
    excerpt: '一位拥有十年经验的 HR 投稿拆解竞业协议：什么岗位会被真正执行、补偿金怎么算、如何合法争取解除，句句干货。',
    channel: 'career',
    author: '做背调的林姐',
    role: '资深 HR',
    verified: 'verified',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20laptop%20and%20contract%20document%20with%20padlock%20in%20warm%20ink%20style%2C%20retro%20newsprint%20cream%20background%2C%20amber%20gold%20and%20vermilion%20accents%2C%20no%20text&width=1200&height=760&seq=cover-career-noncompete&orientation=landscape',
    date: '08-29',
    views: 210500,
    comments: 522,
    heat: 99,
    tags: ['竞业限制', '跳槽', 'HR 视角'],
    body: [
      { type: 'p', text: '先给结论：真正会被执行的竞业，比例远低于很多人想象的。过去十年我经手和见过的竞业案例里，绝大多数停留在「签了但不执行」，真正起诉的往往是掌握核心算法、核心客户或核心技术的岗位。' },
      { type: 'h', text: '公司一般怎么判断要不要执行' },
      { type: 'ul', text: '岗位是否签了「竞业与保密」双协议且明确列为限制对象' },
      { type: 'ul', text: '离职后是否仍在竞业期限内接触竞争对手核心业务' },
      { type: 'ul', text: '公司是否愿意为此每月支付不低于离职前月薪 30% 的补偿' },
      { type: 'quote', text: '如果公司连补偿金都不发，法律上你通常可以主张解除竞业约定。重点是别自己闷头扛，收集证据后再谈。' },
      { type: 'h', text: '给正在考虑跳槽的你三条建议' },
      { type: 'ul', text: '离职前回看劳动合同附件，确认是否属于「签了就生效」的条款' },
      { type: 'ul', text: '新岗位若触发限制，先请新公司 HR 评估，再决定是否申请解除' },
      { type: 'ul', text: '补偿未按时支付，保留工资流水与催告记录，作为主张依据' },
      { type: 'p', text: '本文为资深从业者经验分享，不构成法律意见。涉及具体条款，请以劳动合同与专业律师判断为准。' },
    ],
  },
  {
    id: 7,
    title: '某头部电商物流一线员工投稿：旺季补贴与「件量红绿灯」算法的是是非非',
    excerpt: '快递与仓储一线投稿称，旺季来临补贴口径多次变动，红绿灯算法把「冲量」压力传导到末梢。平台方称属正常经营调整。',
    channel: 'platform',
    author: '凌晨分拣员',
    role: '前物流员工',
    verified: 'pending',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20warehouse%20and%20parcel%20boxes%20conveyor%20in%20warm%20ink%20silhouette%2C%20traffic%20light%20chart%20overlay%2C%20cream%20paper%20retro%20texture%2C%20vermilion%20and%20amber%20palette%2C%20no%20text&width=1200&height=760&seq=cover-platform-logistics&orientation=landscape',
    date: '08-28',
    views: 66900,
    comments: 231,
    heat: 76,
    tags: ['电商物流', '旺季补贴', '算法考核'],
    body: [
      { type: 'p', text: '每年的旺季都像打一场硬仗。今年我们这边新上了「件量红绿灯」考核，绿灯正常冲、黄灯观察、红灯就扣补贴系数。一线最直观的感受是：补贴不是「干得多拿得多」，而是「得按系统的节奏干」。' },
      { type: 'h', text: '补贴口径的三次变动' },
      { type: 'ul', text: '8 月上旬：宣布旺季基础补贴 + 冲量加价' },
      { type: 'ul', text: '8 月中旬：补充「红黄绿」动态系数说明' },
      { type: 'ul', text: '9 月初：部分仓点反映红区工时补贴被按比例下调' },
      { type: 'quote', text: '我们希望规则透明：到底按什么算、谁定的系数、能不能申诉。把规则讲清楚，比多贴几块钱更能留人。' },
      { type: 'p', text: '平台方对媒体表示属于「正常的旺季经营调整」。鉴于投稿人与平台口径差异较大且无纸质规则可核对，本条维持「待核实」，欢迎补充一线排班与补贴明细。' },
    ],
  },
  {
    id: 8,
    title: '「画大饼 vs 真金白银」：一份互联网公司股权归属的避坑对照',
    excerpt: '从离职时「期权被作废」的常见纠纷切入，梳理 RSU、期权、行权窗口的区别，帮你把口头承诺变成看得懂的数字。',
    channel: 'career',
    author: '股权研究小组',
    role: '前法务顾问',
    verified: 'verified',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20stock%20chart%20rising%20with%20documents%20and%20coins%20in%20warm%20ink%20style%2C%20retro%20newsprint%20cream%20background%2C%20amber%20and%20vermilion%20accents%2C%20no%20text&width=1200&height=760&seq=cover-career-equity&orientation=landscape',
    date: '08-26',
    views: 187700,
    comments: 445,
    heat: 94,
    tags: ['股权', '期权', '避坑'],
    body: [
      { type: 'p', text: '几乎每个月都有读者来问同一个问题：offer 里写的「期权」，离职时到底能不能带走。今天不讲复杂法律，只讲三件事：它是什么、怎么算、什么时候会踩坑。' },
      { type: 'h', text: '先分清三种最常见的说法' },
      { type: 'ul', text: 'RSU（限制性股票）：多数按归属表逐年解锁，通常离职不影响已归属部分' },
      { type: 'ul', text: '期权：需要「行权」才变成股票，未归属部分离职通常清零' },
      { type: 'ul', text: '口头承诺：未进合同的一律当作不存在来谈' },
      { type: 'quote', text: '判断一句股权承诺值不值钱，就看它有没有写进 offer 或授予协议，以及有没有写清楚归属时间表与离职处理条款。' },
      { type: 'h', text: '离职前的三查' },
      { type: 'ul', text: '查授予协议里的「cliff」与归属表，确认已归属数量' },
      { type: 'ul', text: '查公司是否允许「窗口期」内行权，行权资金与税负要算清' },
      { type: 'ul', text: '查离职流程是否要求签署放弃声明，别顺手签掉已归属权益' },
      { type: 'p', text: '本文来自法务背景投稿人的经验整理，帮助读者建立基本判断框架。个案请务必结合合同条款并咨询专业律师。' },
    ],
  },
  {
    id: 9,
    title: '北京某独角兽被曝「公积金下调到最低档」，知情人士还原薪资结构调整',
    excerpt: '多名员工投稿称入职时承诺的公积金缴纳档位被悄悄下调，折算后的到手变化与招聘口径存在出入。',
    channel: 'tech',
    author: '工位旁边的老哥',
    role: '在职员工',
    verified: 'pending',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20building%20with%20coins%20and%20house%20icon%20in%20warm%20ink%20tone%2C%20balance%20scale%20overlay%2C%20cream%20paper%20retro%20newsprint%20background%2C%20vermilion%20and%20amber%20palette%2C%20no%20text&width=1200&height=760&seq=cover-tech-fund&orientation=landscape',
    date: '08-24',
    views: 54300,
    comments: 176,
    heat: 72,
    tags: ['公积金', '薪资结构', '独角兽'],
    body: [
      { type: 'p', text: '坐标北京一家估值不低的独角兽。老员工陆续发现，每个月到手的社保公积金明细里，公积金基数悄悄回到了最低档。对于按「全额基数 + 双边」谈过薪资的人来说，这落差不算小。' },
      { type: 'h', text: '口径的两面' },
      { type: 'ul', text: '招聘时：多以「全额缴纳、公积金足额」作为卖点' },
      { type: 'ul', text: '执行时：部分员工被按当地最低基数核算' },
      { type: 'quote', text: '公司确实难，但口径要透明。谈薪时说好的全额，执行时悄悄降档，伤的是信任。' },
      { type: 'p', text: '我们收到同公司 8 位员工的投稿，均反映公积金基数调整但未同步书面说明，因缺少官方文件暂标「待核实」。建议当事人先核对公积金对账单，再决定是否维权。' },
    ],
  },
];

export interface HotItem {
  rank: number;
  delta: 'up' | 'down' | 'same' | 'new';
  title: string;
  id: number;
  heat: number;
}

export const hotList: HotItem[] = [
  { rank: 1, delta: 'up', title: '「竞业限制」成为跳槽头号拦路虎，HR 亲述避坑', id: 6, heat: 99 },
  { rank: 2, delta: 'same', title: '华南某智能硬件大厂组织调整补偿口径与时间线', id: 1, heat: 96 },
  { rank: 3, delta: 'up', title: '「画大饼 vs 真金白银」股权归属避坑对照', id: 8, heat: 94 },
  { rank: 4, delta: 'down', title: '沪上某券商投行部年终奖传闻再起', id: 3, heat: 91 },
  { rank: 5, delta: 'up', title: '某内容平台创作者分成出现「隐藏上限」', id: 2, heat: 84 },
  { rank: 6, delta: 'new', title: '某药企研发项目大挪移，管线负责人成谜', id: 5, heat: 81 },
  { rank: 7, delta: 'down', title: '某连锁咖啡品牌门店排班「被砍工时」', id: 4, heat: 78 },
  { rank: 8, delta: 'same', title: '某头部电商物流旺季补贴算法争议', id: 7, heat: 76 },
];

export const topicChannels = ['科技大厂', '金融与投行', '互联网与平台', '医疗与大健康'];